export function scrollPageToTop() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  const mainContent = document.querySelector('.main-content');

  if (mainContent) {
    mainContent.scrollTop = 0;
    if (typeof mainContent.scrollTo === 'function') {
      mainContent.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  }

  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}
